// DS2.7
import React from 'react';
import classnames from 'classnames';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import PlusIcon from '../Icons/AddPlus';
import { IconSize } from '../Icons/IconWrap';
import s from './AddItem.scss';
var AddItem = function (_a) {
    var className = _a.className, onClick = _a.onClick, title = _a.title, titleClassName = _a.titleClassName, disabled = _a.disabled, subtitle = _a.subtitle, biData = _a.biData, innerRef = _a.innerRef, _b = _a.icon, Icon = _b === void 0 ? PlusIcon : _b, _c = _a.iconSize, iconSize = _c === void 0 ? IconSize.TINY : _c;
    return (React.createElement(BiButton, { className: classnames(s['root'], className, disabled && s['disabled']), onClick: onClick, biData: biData, innerRef: innerRef },
        React.createElement(Icon, { className: s['plus'], size: iconSize }),
        title && (React.createElement("div", { className: classnames(s['title'], titleClassName) }, title)),
        subtitle && React.createElement("div", { className: s['subtitle'] }, subtitle)));
};
AddItem.displayName = 'AddItem';
export default AddItem;
//# sourceMappingURL=AddItem.js.map